import CONSTANTS from '../../constants';

export const group = {
  avatar: '',
  banner: 'https://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/img/gallery/default-banner_1170x250.png',
};

export const user = {
  name: 'Hidden',
  groups: [],
  avatar: CONSTANTS.CDN.AVATARS + 'avatar_hidden' + CONSTANTS.AVATAR_SMALL_SUFFIX,
  banner: 'https://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/img/gallery/default-banner_1170x250.png',
};

export const post = {
  formatted: {},
  numRatings: 0,
  totalResponses: 0,
  responses: [],
};



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/data/basicElements.js